const miscContent = `
<div style="margin: 20px 0;">
  <h3>Utility Commands:</h3>
  <p style="margin: 10px 0;">
    <span class="command-link" data-command="secret" style="color: #5abb9a;">[SECRET]</span> - ?????<br>
    <span class="command-link" data-command="ascii-selfie" style="color: #5abb9a;">[ascii-selfie]</span> - See a Selfie of me :)<br>
    <span class="command-link" data-command="calculator" style="color: #5abb9a;">[calculator]</span> - People Build Projects for Calculators, I put Calculators in Projects<br>
    <span class="command-link" data-command="qr-generator" style="color: #5abb9a;">[qr-generator]</span> - Generate QR codes for text/URLs<br>
    <span class="command-link" data-command="password-generator" style="color: #5abb9a;">[password-generator]</span> - Secure password generation<br>
    <span class="command-link" data-command="github-feed" style="color: #5abb9a;">[github-feed]</span> - Live updates from my GitHub repositories<br>
    <span class="command-link" data-command="neofetch" style="color: #5abb9a;">[neofetch]</span> - Neofetch<br>
  </p>
  <div style="height: 8px;"></div>
  <p style="margin: 10px 0;">
    <span class="command-link" data-command="theme" style="color: #5abb9a;">[Theme]</span> - Change current theme<br>    
    <span class="command-link" data-command="hackermode" style="color: #5abb9a;">[hackermode]</span> - Toggle Matrix effect<br>
  </p>
  <div style="height: 8px;"></div>
  <p style="margin: 10px 0;">
    <span class="command-link" data-command="google" style="color: #5abb9a;">[google query]</span> - Search Google<br>
    <span class="command-link" data-command="youtube" style="color: #5abb9a;">[youtube query]</span> - Search YouTube<br>
    <span class="command-link" data-command="wiki" style="color: #5abb9a;">[wiki query]</span> - Search Wikipedia<br>
    <span class="command-link" data-command="chatgpt" style="color: #5abb9a;">[chatgpt query]</span> - Search ChatGPT<br>
    <span class="command-link" data-command="perplexity" style="color: #5abb9a;">[perplexity query]</span> - Search Perplexity<br>
  </p>
</div>`;

export default miscContent;